// Sprint 1 — Onboarding post-registro
import { Building2, Video } from "lucide-react";
import { css, cx } from "styled-system/css";
import { cf } from "@/components/brand/sfturnos-styles";
import { useOnboardingWizard } from "@/context/onboarding-wizard-context";
import { onboardingChoiceCard } from "../onboarding-ui";

export function OnboardingStepNameModality() {
  const { state, dispatch } = useOnboardingWizard();
  const nameOk = state.name.trim().length > 0;
  const canContinue = nameOk && (state.modality === "virtual" || state.modality === "presencial");

  return (
    <div>
      <div className={css({ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2", mb: "4" })}>
        <span className={css({ fontSize: "xs", color: "#64748b" })}>Rubro</span>
        <span
          className={css({
            fontSize: "xs",
            fontWeight: "semibold",
            px: "2.5",
            py: "1",
            rounded: "full",
            bg: "rgba(99, 102, 241, 0.12)",
            color: "token(colors.brand.700)",
          })}
        >
          {state.rubro || "—"}
        </span>
      </div>

      <h1 className={css({ fontSize: "2xl", fontWeight: "bold", color: "#0f172a", mb: "6" })}>
        Nombre y modalidad
      </h1>

      <label className={css({ display: "block", mb: "6" })}>
        <span className={css({ fontSize: "sm", fontWeight: "medium", color: "#334155", display: "block", mb: "2" })}>
          ¿Cuál es tu nombre o el de tu negocio?
        </span>
        <input
          type="text"
          value={state.name}
          onChange={(e) => dispatch({ type: "SET_FIELD", field: "name", value: e.target.value })}
          className={cf.input}
          placeholder="Ej. Estudio Luna"
          autoComplete="organization"
        />
        <span className={css({ fontSize: "xs", color: "#64748b", mt: "1.5", display: "block" })}>
          Este nombre lo verán tus clientes al reservar.
        </span>
      </label>

      <p className={css({ fontSize: "sm", fontWeight: "semibold", color: "#0f172a", mb: "3" })}>Modalidad</p>
      <div className={css({ display: "grid", gap: "4", mb: "8" })}>
        <button
          type="button"
          onClick={() => dispatch({ type: "SET_FIELD", field: "modality", value: "virtual" })}
          className={cx(
            onboardingChoiceCard({ selected: state.modality === "virtual", wide: true }),
            css({ border: "none", font: "inherit", alignItems: "flex-start" }),
          )}
        >
          <Video
            className={css({
              w: "7",
              h: "7",
              color: state.modality === "virtual" ? "token(colors.brand.500)" : "#64748b",
            })}
            strokeWidth={1.75}
          />
          <span className={css({ fontWeight: "semibold", color: "#0f172a" })}>Virtual</span>
          <span className={css({ fontSize: "sm", color: "#64748b", lineHeight: 1.5 })}>
            El turno será en modalidad virtual.
          </span>
        </button>
        <button
          type="button"
          onClick={() => dispatch({ type: "SET_FIELD", field: "modality", value: "presencial" })}
          className={cx(
            onboardingChoiceCard({ selected: state.modality === "presencial", wide: true }),
            css({ border: "none", font: "inherit", alignItems: "flex-start" }),
          )}
        >
          <Building2
            className={css({
              w: "7",
              h: "7",
              color: state.modality === "presencial" ? "token(colors.brand.500)" : "#64748b",
            })}
            strokeWidth={1.75}
          />
          <span className={css({ fontWeight: "semibold", color: "#0f172a" })}>Presencial</span>
          <span className={css({ fontSize: "sm", color: "#64748b", lineHeight: 1.5 })}>
            El turno será presencial en tu local.
          </span>
        </button>
      </div>

      {canContinue ? (
        <button
          type="button"
          onClick={() => dispatch({ type: "NEXT_STEP" })}
          className={cx(
            cf.linkPrimaryOnDark,
            css({
              px: "6",
              py: "3",
              border: "none",
              fontSize: "sm",
              cursor: "pointer",
              bg: "linear-gradient(90deg, token(colors.brand.600), token(colors.brand.500))",
            }),
          )}
        >
          Continuar
        </button>
      ) : null}
    </div>
  );
}
